import { isValidDateSubmit } from "./dateField";
import { parseIsoDate } from "../dates/isoDate";

export type DateRangeValue = { start: string; end: string };

export function parseDateRangeValue(raw: unknown): DateRangeValue | null {
  let value: unknown = raw;
  if (typeof value === "string") {
    if (!value.trim()) return null;
    try {
      value = JSON.parse(value);
    } catch {
      return null;
    }
  }

  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return null;
  }

  const record = value as Record<string, unknown>;
  if (!("start" in record) && !("end" in record)) return null;
  if (
    (record.start != null && typeof record.start !== "string") ||
    (record.end != null && typeof record.end !== "string")
  ) {
    return null;
  }

  return {
    start: String(record.start ?? "").trim(),
    end: String(record.end ?? "").trim(),
  };
}

export function dateRangeValidationMessage(
  raw: unknown,
  withTime: boolean,
  required: boolean,
): string | null {
  const range = parseDateRangeValue(raw);
  if (!range) {
    return !required && (raw == null || raw === "")
      ? null
      : "Укажите даты «С» и «По»";
  }
  if (!range.start && !range.end) {
    return required ? "Укажите даты «С» и «По»" : null;
  }
  if (!range.start || !range.end) return "Укажите обе границы интервала";

  const pattern = withTime
    ? /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/
    : /^\d{4}-\d{2}-\d{2}$/;
  if (
    !pattern.test(range.start) ||
    !pattern.test(range.end) ||
    !isValidDateSubmit(range.start, withTime) ||
    !isValidDateSubmit(range.end, withTime)
  ) {
    return "Укажите корректные даты интервала";
  }
  if (range.end < range.start) return "Дата «По» раньше даты «С»";
  return null;
}

export function dateRangeDayCount(raw: unknown): number | null {
  const range = parseDateRangeValue(raw);
  if (!range) return null;
  const withTime = range.start.includes("T") || range.end.includes("T");
  if (dateRangeValidationMessage(range, withTime, true)) return null;

  const start = parseIsoDate(range.start.slice(0, 10));
  const end = parseIsoDate(range.end.slice(0, 10));
  if (!start || !end) return null;
  const startUtc = Date.UTC(
    start.getFullYear(),
    start.getMonth(),
    start.getDate(),
  );
  const endUtc = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());
  return Math.round((endUtc - startUtc) / 86_400_000) + 1;
}

export function formatDateRangeDayCount(raw: unknown): string | null {
  const count = dateRangeDayCount(raw);
  if (count == null) return null;
  const lastTwo = count % 100;
  const lastOne = count % 10;
  const noun =
    lastTwo >= 11 && lastTwo <= 14
      ? "дней"
      : lastOne === 1
        ? "день"
        : lastOne >= 2 && lastOne <= 4
          ? "дня"
          : "дней";
  return `${count} ${noun}`;
}
